import React from 'react';

interface BequestAssetCardProps {
  assetCategory: string;
  assetTitle: string;
}

function BequestAssetCard({
  assetCategory,
  assetTitle,
}: BequestAssetCardProps) {
  return (
    <div className="t-rounded t-border t-border-solid t-border-delta-300 t-p-3">
      <p className="typo-zeta">{assetCategory}</p>
      <h2 className="typo-beta">{assetTitle}</h2>
    </div>
  );
}

export default BequestAssetCard;
